import { Handler } from "../interfaces/Handler.interface";

/**
 * [Impure] Run listener functions with (current value from store, previous value).
 * @param handler - Object containing event listeners.
 * @param key - Key to run listeners for.
 * @param value - value to pass to listeners.
 * @param previousValue - Optional previous value.
 */
export function emit(handler: Handler, key: string, value: any, previousValue?: any) {
    const globals = (handler["*"] && handler["*"].length) ? handler["*"] : null;
    const listeners = (handler[key] && handler[key].length) ? handler[key] : null;
    if (globals) for (let i = 0; i < globals.length; i++) globals[i](value, previousValue, key);
    if (listeners) for (let i = 0; i < listeners.length; i++) listeners[i](value, previousValue, key);
}
